import HLSPlayer from './HLSPlayer'
export default HLSPlayer



// WEBPACK FOOTER //
// ./src/components/HLSPlayer/index.js